import { Navigate, useLocation } from "react-router-dom";
import {
    loaderById,
    loaderDashboard,
    loaderGrid,
    loaderReport,
} from "../../middleware/route-provider.js";

import BasicInformationService from "../../../infrastructure/api/basicInformation.js";
import CustomerRequestLocationService from "../../../infrastructure/api/customerRequestLocation.js";
import DefaultApiService from "../../../infrastructure/api/default.js";
import RoleGuardRoute from "../../components/layout/RoleGuardRoute.js";
import { consultationSolarentOperatorApi } from "../../../infrastructure/api/consultation.js";
import { customerWithoutRequestLeadOperatorApi } from "../../../infrastructure/api/customerWithoutRequestLead.js";
import { exhibitionBoothLeadOperatorApi } from "../../../infrastructure/api/exhibitionBoothLead.js";

import SLNPage from "./index.js";

// ================ Customer ========================================================

import ContractorSelectionPage from "./customer/ContractorSelection.js";
import CustomerProfileModifyPage from "./customer/customer-profile/CustomerProfileModify.js";
import CustomerProfilePage from "./customer/customer-profile/index.js";
import SLNCustomerPage from "./customer/index.js";
import CustomerPowerPurchaseAgreementPage from "./customer/power-purchase-agreement/index.js";
import CustomerPowerPurchaseAgreementModifyPage from "./customer/power-purchase-agreement/PowerPurchaseAgreementModify.js";
import CustomerProjectContractPage from "./customer/project-contract/index.js";
import CustomerProjectContractModifyPage from "./customer/project-contract/ProjectContractModify.js";
import CustomerLoanSimulatorPage from "./customer/loan/CustomerLoanSimulatorPage.js";
import CustomerRequestsInfoPage from "./customer/requests/CustomerRequestsInfo.js";
import FinancialReportPage from "./customer/FinancialReport.js";
import GenerationReportPage from "./customer/GenerationReport.js";
import TariffHistoryPage from "./customer/TariffHistory.js";
import PlantsPage from "./customer/Plants.js";
import CustomerRequestsModifyPage from "./customer/requests/CustomerRequestsModify.js";
import CustomerAssistedRegistrationCorrectionPage from "./customer/AssistedRegistrationCorrectionPage.js";
import CustomerRequestsPage from "./customer/requests/index.js";
import { normalizeCustomerRequestForForm } from "./shared/checkNewRequest/checkNewRequestPageUtils.js";
import { resolvePlantCapacityOptions, unwrapCustomerRequestFormEnums } from "./shared/customerRequest/plantCapacityFormConstants.js";
import CustomerPriceOfferContractPage from "./customer/price-offer-contract/CustomerPriceOfferContractPage.js";
import CustomerApplicantContractSignPage from "./customer/applicant-contract-sign/CustomerApplicantContractSignPage.js";
import CustomerSupplierProjectContractModifyPage from "./customer/supplier-project-contract/CustomerSupplierProjectContractModify.js";
import CustomerSupplierProjectContractPage from "./customer/supplier-project-contract/index.js";
import CustomerPaymentResultPage from "./customer/payment/CustomerPaymentResultPage.js";
import CustomerInvoicePaymentPage from "./customer/payment/CustomerInvoicePaymentPage.js";
import CustomerBalanceTopUpPage from "./customer/balance/CustomerBalanceTopUpPage.js";
import CustomerBalanceHistoryPage from "./customer/balance/CustomerBalanceHistoryPage.js";
import TestGatewayPaymentPage from "./payment-gateway/TestGatewayPaymentPage.js";
//=========================== Management =============================================

import Below200KWStepInfoModifyPage from "./management/below200KWStepInfo/Below200KWStepInfoModify.js";
import Below200KWStepInfoPage from "./management/below200KWStepInfo/index.js";
import CheckNewRequestModifyPage from "./management/checkNewRequest/CheckNewRequestModify.js";
import ManagementProjectFinalApprovalPage from "./management/project-final-approval/index.js";
import ManagementProjectExecutionActivationPage from "./management/project-execution-activation/index.js";
import ManagementProjectExecutionPlanPage from "./management/project-execution-plan/index.js";
import ManagementProjectPaymentActivationPage from "./management/project-payment-activation/index.js";
import ManagementProjectProcurementActivationPage from "./management/project-procurement-activation/index.js";
import ManagementProjectMilestoneCoordinationPage from "./management/project-milestone-coordination/index.js";
import CheckNewRequestPage from "./management/checkNewRequest/index.js";
import ManagementAllRequestPage from "./management/all-request/index.js";
import CompletedRequestPage from "./management/completed-request/index.js";
import ManagementContractorInfoInformationPage from "./management/contractor-info/ContractorInfoInformation.js";
import ManagementContractorInfoModifyPage from "./management/contractor-info/ContractorInfoModify.js";
import ManagementContractorInfoPage from "./management/contractor-info/index.js";
import EquipmentMasterCatalogPage from "./management/equipment-master-catalog/index.js";
import EquipmentMasterCatalogModify from "./management/equipment-master-catalog/EquipmentMasterCatalogModify.js";
import EquipmentCategoryManagement from "./management/equipment-master-catalog/EquipmentCategoryManagement.js";
import EquipmentBrandManagement from "./management/equipment-master-catalog/EquipmentBrandManagement.js";
import EquipmentItemRequests from "./management/equipment-master-catalog/EquipmentItemRequests.js";
import ContractorEquipmentItemRequestsPage from "./contractor/equipment-item-requests/index.js";
import DistributionCompaniesPage from "./management/distribution-network/DistributionCompaniesPage.js";
import DistributionCompanyModifyPage from "./management/distribution-network/DistributionCompanyModifyPage.js";
import DistributionAreasPage from "./management/distribution-network/DistributionAreasPage.js";
import DistributionAreaModifyPage from "./management/distribution-network/DistributionAreaModifyPage.js";
import DistributionContactsPage from "./management/distribution-network/DistributionContactsPage.js";
import DistributionContactModifyPage from "./management/distribution-network/DistributionContactModifyPage.js";
import DistributionNetworkExplorerPage from "./management/distribution-network/DistributionNetworkExplorerPage.js";
import ManagementContractorReferralReportPage from "./management/contractor-referral/ContractorReferralReportPage.js";
import ManagementContractorRegistrationModifyPage from "./management/contractor-registration/ContractorRegistrationModify.js";
import ContractorMasterContractOperatorPage from "./management/contractor-master-contract/ContractorMasterContractOperatorPage.js";
import ManagementContractorRegistrationPage from "./management/contractor-registration/index.js";
import CustomerInfoModifyPage from "./management/customer-info/CustomerInfoModify.js";
import CustomerInfoPage from "./management/customer-info/index.js";
import DeleteRequestPage from "./management/deleted-requests/index.js";
import GasStepInfoModifyPage from "./management/gasStepInfo/GasStepInfoModify.js";
import GasStepInfoPage from "./management/gasStepInfo/index.js";
import SLNManagementPage from "./management/index.js";
import IndividualBranchingStepInfoPage from "./management/individual-branching-stepInfo/index.js";
import IndividualBranchingStepInfoModifyPage from "./management/individual-branching-stepInfo/IndividualBranchingStepInfoModify.js";
import IndividualNonSplitStepInfoPage from "./management/individual-non-split-stepInfo/index.js";
import IndividualNonSplitStepInfoModifyPage from "./management/individual-non-split-stepInfo/IndividualNonSplitStepInfoModify.js";
import InProcessRequestPage from "./management/inProcessRequest/index.js";
import InProcessRequestModifyPage from "./management/inProcessRequest/InProcessRequestModify.js";
import RejectedRequestsPage from "./management/rejected-requests/index.js";
import ManagementInitialReviewFollowUpPage from "./management/initial-review-follow-up/index.js";
import ComprehensiveReportPage from "./management/reports/ComprehensiveReport.js";
import FeederAvailableCapacitiesReportPage from "./management/reports/FeederAvailableCapacitiesReport.js";
import MapReportPage from "./management/reports/MapReport.js";
import StationSearchPage from "./management/reports/StationSearch.js";
import SendGroupSMSPage from "./management/send-group-sms/SendGroupSMS.js";
import ProfileApprovalPage from "./management/profile-approval/index.js";
import ProfileApprovalDetailPage from "./management/profile-approval/ProfileApprovalDetail.js";
import ConsultationRequestsPage from "./management/consultation-requests/index.js";
import ConsultationSettingsPage from "./management/consultation-settings/index.js";
import ExhibitionBoothLeadsPage from "./management/exhibition-booth-leads/index.js";
import BankReconciliationPage from "./management/bank-reconciliation/index.js";
import GuaranteeChequeCustodyPage from "./management/guarantee-cheque-custody/index.js";
import WarehouseSlipsPage from "./management/warehouse-slips/index.js";
import WarehouseCheckingPage from "./management/warehouse-checking/index.js";
import CustomerWithoutRequestLeadsPage from "./shared/customer-without-request-leads/index.js";
import { marketGrowthSlnRouteEntries } from "./market-growth/slnRouteEntries.js";
import { contractorPortalSlnRouteEntries } from "./contractor-portal/slnRouteEntries.js";

// ==================== SolarentOperator ==============================================================================

import SolarentOperatorAllRequestsPage from "./solarent-operator/all-requests/index.js";
import SolarentOperatorApplicantContractsPage from "./solarent-operator/applicant-contracts/index.js";
import SolarentOperatorApplicantContractFeeSettingsPage from "./solarent-operator/applicant-contract-fee-settings/index.js";
import SolarentOperatorApplicantRegistrationPage from "./solarent-operator/applicant-registration/index.js";
import SolarentOperatorInitialReviewFollowUpPage from "./solarent-operator/initial-review-follow-up/index.js";
import SolarentOperatorMehrsanWorkQueuePage from "./solarent-operator/mehrsan-queue/index.js";
import SolarentOperatorBarghPayWorkQueuePage from "./solarent-operator/barghpay/index.js";
import SolarentOperatorIriaPayWorkQueuePage from "./solarent-operator/iriapay/index.js";
import SolarentOperatorLoanDisbursementsPage from "./solarent-operator/loan-disbursements/index.js";
import SolarentOperatorContractorReferralWorkQueuePage from "./solarent-operator/contractor-referral-queue/index.js";
import SolarentOperatorSupervisionWorkQueuePage from "./solarent-operator/supervision-queue/index.js";
import SolarentOperatorFulfillmentWorkQueuePage from "./solarent-operator/fulfillment-queue/index.js";
import SolarentOperatorSalesProformaPage from "./solarent-operator/sales-proforma/index.js";
import ManagementSalesProformaPage from "./management/sales-proforma/index.js";
import {
  LegacyReviewQueueRedirect,
  LegacyTeamRedirect,
} from "../EDC/LegacyDistributionRedirects.js";
import SolarentOperatorAllRequestsModifyPage from "./solarent-operator/all-requests/SolarentOperatorAllRequestsModify.js";
import SolarentOperatorCheckNewRequestPage from "./solarent-operator/checkNewRequest/index.js";
import SolarentOperatorCheckNewRequestModifyPage from "./solarent-operator/checkNewRequest/SolarentOperatorCheckNewRequestModify.js";
import SolarentOperatorProjectFinalApprovalPage from "./solarent-operator/project-final-approval/index.js";
import SolarentOperatorProjectExecutionActivationPage from "./solarent-operator/project-execution-activation/index.js";
import SolarentOperatorProjectExecutionPlanPage from "./solarent-operator/project-execution-plan/index.js";
import SolarentOperatorProjectPaymentActivationPage from "./solarent-operator/project-payment-activation/index.js";
import SolarentOperatorProjectProcurementActivationPage from "./solarent-operator/project-procurement-activation/index.js";
import SolarentOperatorProjectMilestoneCoordinationPage from "./solarent-operator/project-milestone-coordination/index.js";
import SolarentOperatorContractorInfoModifyPage from "./solarent-operator/contractor-info/ContractorInfoModify.js";
import SolarentOperatorContractorRegistrationModifyPage from "./solarent-operator/contractor-registration/ContractorRegistrationModify.js";
import SolarentOperatorContractorRegistrationPage from "./solarent-operator/contractor-registration/index.js";
import SolarentOperatorContractorInfoPage from "./solarent-operator/contractor-info/index.js";
import SolarentOperatorContractorProjectContractPage from "./solarent-operator/contractor-project-contract/index.js";
import SolarentOperatorContractorProjectContractModifyPage from "./solarent-operator/contractor-project-contract/SolarentOperatorContractorProjectContractModify.js";
import SolarentOperatorPage from "./solarent-operator/index.js";
import OperatorLoanSimulatorPage from "./solarent-operator/loan-simulator/index.js";
import OperatorApplicantSmsPage from "./solarent-operator/applicant-sms/index.js";
import SolarentOperatorInProcessRequestPage from "./solarent-operator/inProcessRequest/index.js";
import SolarentOperatorInProcessRequestModifyPage from "./solarent-operator/inProcessRequest/SolarentOperatorInProcessRequestModify.js";
import SolarentOperatorProjectWorkspacePage from "./solarent-operator/project-workspace/SolarentOperatorProjectWorkspacePage.js";
import ProjectWorkspaceRedirect from "./shared/projectWorkspace/ProjectWorkspaceRedirect.js";
import ProjectWorkspaceHubPage from "./shared/projectWorkspace/ProjectWorkspaceHubPage.js";
import { loaderProjectWorkspaceHub } from "./shared/projectWorkspace/projectWorkspaceHubLoader.js";
import ManagementProjectWorkspacePage from "./management/project-workspace/ManagementProjectWorkspacePage.js";
import SolarentOperatorRejectedRequestsPage from "./solarent-operator/rejected-requests/index.js";
import SolarentOperatorRejectedRequestModifyPage from "./solarent-operator/rejected-requests/SolarentOperatorRejectedRequestModify.js";
import SolarentOperatorRequestPage from "./solarent-operator/request/index.js";
import SolarentOperatorRequestInfoPage from "./solarent-operator/request/SolarentOperatorRequestInfo.js";
import SolarentOperatorRequestModifyPage from "./solarent-operator/request/SolarentOperatorRequestModify.js";
import SolarentOperatorSupervisorInfoPage from "./solarent-operator/supervisor-info/index.js";
import SolarentOperatorSupervisorInfoModifyPage from "./solarent-operator/supervisor-info/SupervisorInfoModify.js";
import SolarentOperatorSupplierInfoPage from "./solarent-operator/supplier-info/index.js";
import SolarentOperatorSupplierInfoModifyPage from "./solarent-operator/supplier-info/SupplierInfoModify.js";
import SolarentOperatorSupplierProjectContractPage from "./solarent-operator/supply-contract/index.js";
import SolarentOperatorSupplierProjectContractModifyPage from "./solarent-operator/supply-contract/SolarentOperatorSupplierProjectContractModify.js";
import SolarentOperatorProfileApprovalPage from "./solarent-operator/profile-approval/index.js";
import SolarentOperatorProfileApprovalDetailPage from "./solarent-operator/profile-approval/ProfileApprovalDetail.js";
// ==================== Supervisor ==============================================================================

import SupervisorContractorProjectContractPage from "./supervisor/contractor-project-contract/index.js";
import SupervisorContractorProjectContractModifyPage from "./supervisor/contractor-project-contract/SupervisorContractorProjectContractModify.js";
import SupervisorPage from "./supervisor/index.js";
import SupervisorInProcessRequestModifyPage from "./supervisor/inProcessRequest/SupervisorInProcessRequestModify.js";
import PowerPurchaseAgreementPage from "./supervisor/power-purchase-agreement/index.js";
import PowerPurchaseAgreementModifyPage from "./supervisor/power-purchase-agreement/PowerPurchaseAgreementModify.js";
import SupervisorProjectDesignPage from "./supervisor/project-design/index.js";
import SupervisorProjectDesignModifyPage from "./supervisor/project-design/ProjectDesignModify.js";
import SupervisorRejectedRequestsPage from "./supervisor/rejected-requests/index.js";
import SupervisorRejectedRequestModifyPage from "./supervisor/rejected-requests/SupervisorRejectedRequestModify.js";
import SupervisorRequestPage from "./supervisor/request/index.js";
import SupervisorRequestInfoPage from "./supervisor/request/SupervisorRequestInfo.js";
import SupervisorRequestModifyPage from "./supervisor/request/SupervisorRequestModify.js";
import SiteVisitPage from "./supervisor/site-visit/index.js";
import SiteVisitModifyPage from "./supervisor/site-visit/SiteVisitModify.js";
import SupervisorInfoPage from "./supervisor/supervisor-info/index.js";
import SupervisorInfoModifyPage from "./supervisor/supervisor-info/SupervisorInfoModify.js";

import SupervisorOperationLicensePage from "./supervisor/operation-license/index.js";
import SupervisorOperationLicenseModifyPage from "./supervisor/operation-license/OperationLicenseModify.js";
import SupervisorProjectExecutionSchedulePage from "./supervisor/project-execution-schedule/index.js";
import SupervisorProjectExecutionScheduleModifyPage from "./supervisor/project-execution-schedule/ProjectExecutionScheduleModify.js";
import SupervisorProjectGridConnectionPage from "./supervisor/project-grid-connection/index.js";
import SupervisorProjectGridConnectionModifyPage from "./supervisor/project-grid-connection/ProjectGridConnectionModify.js";
import SupervisorProjectPlantConstructionPage from "./supervisor/project-plant-construction/index.js";
import SupervisorProjectPlantConstructionModifyPage from "./supervisor/project-plant-construction/ProjectPlantConstructionModify.js";
import SupervisorProjectAssignmentsPage from "./supervisor/project-assignments/index.js";
import SupervisorExecutionMilestonesPage from "./supervisor/execution-milestones/index.js";
import SupervisorInstalledEquipmentPage from "./supervisor/installed-equipment/index.js";
import SupervisorProjectTestPage from "./supervisor/project-test/index.js";
import SupervisorProjectTestModifyPage from "./supervisor/project-test/ProjectTestModify.js";

// ==================== Satba (Ministry of Energy) ==============================================================================
import SatbaDashboardPage from "./satba/index.js";

// ==================== Contractor ==============================================================================

import ContractorInfoModifyPage from "./contractor/contractor-info/ContractorInfoModify.js";
import ContractorInfoPage from "./contractor/contractor-info/index.js";
import ContractorInProcessRequestModifyPage from "./contractor/inProcessRequest/ContractorInProcessRequestModify.js";
import ContractorInProcessRequestPage from "./contractor/inProcessRequest/index.js";
import ContractorPackageManagementPage from "./contractor/package-management/index.js";
import ContractorReferralPage from "./contractor/ContractorReferralPage.js";
import ContractorReferralLeadsPage from "./contractor/ContractorReferralLeadsPage.js";
import ContractorAssistedRegistrationPage from "./contractor/ContractorAssistedRegistrationPage.js";
import ContractorTeamPage from "./contractor/ContractorTeamPage.js";
import ContractorPackageModifyPage from "./contractor/package-management/PackageModify.js";
import ProjectContractCheckingPage from "./contractor/project-contract/index.js";
import ProjectContractCheckingModifyPage from "./contractor/project-contract/ProjectContractCheckingModify.js";
import ContractorProjectDesignPage from "./contractor/project-design/index.js";
import ContractorProjectDesignModifyPage from "./contractor/project-design/ProjectDesignModify.js";
import ContractorProjectExecutionSchedulePage from "./contractor/project-execution-schedule/index.js";
import ContractorProjectExecutionScheduleModifyPage from "./contractor/project-execution-schedule/ProjectExecutionScheduleModify.js";
import ContractorProjectGridConnectionPage from "./contractor/project-grid-connection/index.js";
import ContractorProjectGridConnectionModifyPage from "./contractor/project-grid-connection/ProjectGridConnectionModify.js";
import ContractorProjectPlantConstructionPage from "./contractor/project-plant-construction/index.js";
import ContractorProjectPlantConstructionModifyPage from "./contractor/project-plant-construction/ProjectPlantConstructionModify.js";
import ContractorProjectAssignmentsPage from "./contractor/project-assignments/index.js";
import ContractorExecutionMilestonesPage from "./contractor/execution-milestones/index.js";
import ContractorProjectQuotesPage from "./contractor/project-quotes/index.js";
import ContractorProjectContractAcceptancePage from "./contractor/project-contract-acceptance/index.js";
import ContractorProjectWorkspaceRedirect from "./contractor/project-workspace/ContractorProjectWorkspaceRedirect.js";
import ContractorProjectTestPage from "./contractor/project-test/index.js";
import ContractorProjectTestModifyPage from "./contractor/project-test/ProjectTestModify.js";
import ContractorSiteVisitPage from "./contractor/site-visit/index.js";
import ContractorSiteVisitModifyPage from "./contractor/site-visit/SiteVisitModify.js";

// ====================== Tickets =========================================================================
import TicketsListPage from "./tickets/TicketsList.js";
import TicketDetailPage from "./tickets/TicketDetail.js";

// ====================== SMS Reports ====================================================================
import SmsReportsPage from "./management/reports/SmsReports.js";
import FollowUpPerformanceReportPage from "./management/reports/FollowUpPerformanceReport.js";
import LeadConsultationFollowUpPerformanceReportPage from "./management/reports/LeadConsultationFollowUpPerformanceReport.js";
import ManagementOperationalProcessesReportPage from "./management/reports/OperationalProcessesReport.js";
import SolarentOperatorOperationalProcessesReportPage from "./solarent-operator/reports/OperationalProcessesReport.js";
import ManagementOperationsOwnerPerformanceReportPage from "./management/reports/OperationsOwnerPerformanceReport.js";
import SolarentOperatorOperationsOwnerPerformanceReportPage from "./solarent-operator/reports/OperationsOwnerPerformanceReport.js";
import MySmsHistoryPage from "./reports/MySmsHistory.js";

// ====================== Supplier  =========================================================================

import SupplierPage from "./supplier/index.js";
import PackageManagementPage from "./supplier/package-management/index.js";
import PackageModifyPage from "./supplier/package-management/PackageModify.js";
import SupplierInfoPage from "./supplier/supplier-info/index.js";
import SupplierInfoModifyPage from "./supplier/supplier-info/SupplierInfoModify.js";
import SupplierProjectContractPage from "./supplier/supplier-project-contract/index.js";
import SupplierProjectContractModifyPage from "./supplier/supplier-project-contract/SupplierProjectContractModify.js";
import SupplierExecutionMilestonesPage from "./supplier/execution-milestones/index.js";
import SupplierEquipmentProductsPage from "./supplier/equipment-products/index.js";

// ====================== Investor  =========================================================================

import InvestorDashboardPage from "./investor/index.js";

/** روت اصلی /SLN: در صورت نیاز به defaultUrl فقط یک‌بار redirect می‌کند تا از لوپ جلوگیری شود */
function SLNRootRoute() {
  const location = useLocation();
  if (typeof window === "undefined") return <SLNPage />;

  let isShowMainMenu = window.localStorage.getItem("isShowMainMenu");
  const defaultUrl = window.localStorage.getItem("defaultUrl");

  if (isShowMainMenu === null) isShowMainMenu = undefined;
  else if (isShowMainMenu === "false") isShowMainMenu = false;
  else if (isShowMainMenu === "true") isShowMainMenu = true;

  const shouldRedirect =
    (isShowMainMenu === false || isShowMainMenu === "false") &&
    defaultUrl &&
    defaultUrl !== location.pathname;

  if (shouldRedirect) return <Navigate to={defaultUrl} replace />;
  return <SLNPage />;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  path: "SLN",
  children: [
    {
      path: "",
      element: <SLNRootRoute />,
    },
    {
      path: "Customer",
      element: <SLNCustomerPage />,
      loader: async () =>
        await loaderDashboard({
          url: "SLN/Customer",
        }),
    },

    // Supplier
    {
      path: "Supplier",
      element: <SupplierPage />,
      loader: async () =>
        await loaderDashboard({
          url: "SLN/Supplier",
        }),
    },

    {
      path: "Supplier/SupplierInfo",
      element: <SupplierInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supplier/SupplierInfo",
        }),
    },
    {
      path: "Supplier/SupplierInfo/:id",
      element: <SupplierInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            supplierInfo: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/Supplier/SupplierInfo",
        });
      },
    },
    {
      path: "Supplier/SupplierProjectContract",
      element: <SupplierProjectContractPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supplier/SupplierProjectContract",
        }),
    },
    {
      path: "Supplier/SupplierProjectContract/:id",
      element: <SupplierProjectContractModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            supplierProjectContract: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/Supplier/SupplierProjectContract",
        });
      },
    },

    {
      path: "Supplier/ExecutionMilestones",
      element: <SupplierExecutionMilestonesPage />,
    },
    {
      path: "Supplier/EquipmentProducts",
      element: <SupplierEquipmentProductsPage />,
    },

    // Supplier Package Management
    {
      path: "Supplier/PackageManagement",
      element: <PackageManagementPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supplier/PackageManagement",
        }),
    },
    {
      path: "Supplier/PackageManagement/:id",
      element: <PackageModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            package: {
              title: "",
              capacityType: "",
              capacity: 0,
              price: 0,
              discountPercent: 0,
              description: "",
              equipments: [],
              features: [],
            },
            plantCapacity: [],
            mode: "create",
          },
          url: "SLN/Supplier/PackageManagement",
        });
      },
    },

    {
      path: "Customer/ProjectContract",
      element: <CustomerProjectContractPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Customer/ProjectContract",
        }),
    },
    {
      path: "Customer/ProjectContract/:id",
      element: <CustomerProjectContractModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectContract: {
              title: "",
              price: 0,
              description: "",
              startDateTime: "",
              endDateTime: "",
            },
            mode: "create",
          },
          url: "SLN/Customer/ProjectContract",
        });
      },
    },

    {
      path: "Customer/PowerPurchaseAgreement",
      element: <CustomerPowerPurchaseAgreementPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Customer/PowerPurchaseAgreement",
        }),
    },
    {
      path: "Customer/PowerPurchaseAgreement/:id",
      element: <CustomerPowerPurchaseAgreementModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            powerPurchaseAgreement: {
              requestId: 0,
              supervisorInfoId: 0,
              customerInfoId: 0,
              userId: 0,
              title: "",
              description: "",
              contractFileUrl: "",
              powerPurchaseAgreementStatus: "Pending",
              startDateTime: "",
              endDateTime: "",
              actualEndDateTime: "",
              isActive: true,
              customerFullName: "",
            },
            mode: "create",
          },
          url: "SLN/Customer/PowerPurchaseAgreement",
        });
      },
    },

    {
      path: "Customer/CustomerProfile",
      element: <CustomerProfilePage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Customer/CustomerProfile",
        }),
    },
    {
      path: "Customer/CustomerProfile/:id",
      element: <CustomerProfileModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            customerInfo: {
              guid: "",
              title: "",
              agreementKind: "Real",
              address: "",
              telephon: "",
              postalCode: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              nationalCardUrl: "",
              birthCertificateUrl: "",
              description: "",
              fullName: "",
              isActive: true,
              updateOn: "",
            },
            mode: "create",
          },
          url: "SLN/Customer/CustomerProfile",
        });
      },
    },
    {
      path: "Customer/SupplierProjectContract",
      element: <CustomerSupplierProjectContractPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Customer/SupplierProjectContract",
        }),
    },
    {
      path: "Customer/SupplierProjectContract/:id",
      element: <CustomerSupplierProjectContractModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            supplierProjectContract: {
              title: "",
              price: 0,
              description: "",
              startDateTime: "",
              endDateTime: "",
              isActive: true,
            },
            mode: "create",
          },
          url: "SLN/Customer/SupplierProjectContract",
        });
      },
    },
    {
      path: "Customer/LoanSimulator",
      element: <CustomerLoanSimulatorPage />,
    },
    {
      path: "Customer/Requests",
      element: <CustomerRequestsPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Customer/Requests",
        }),
    },
    {
      path: "Customer/AssistedRegistrationCorrection",
      element: <CustomerAssistedRegistrationCorrectionPage />,
    },
    {
      path: "Customer/PriceOfferContract/:requestId",
      element: <CustomerPriceOfferContractPage />,
    },
    {
      path: "Customer/ApplicantContractSign/:requestId",
      element: <CustomerApplicantContractSignPage />,
    },
    {
      path: "Customer/Requests/:id",
      element: <CustomerRequestsModifyPage />,
      loader: async ({ params }) => {
        const defaultRequest = {
          address: "",
          agreementKind: "Real",
          projectCapacity: "",
          projectKind: "",
          xPoint: "",
          yPoint: "",
          requestConfirm: "",
          isActive: true,
          note: "",
          uploadedFileUrl: "",
          companyNationalCode: "",
          companyRegisterationCode: "",
          postalCode: "",
          feederZone: "",
          provinceId: "",
          cityId: "",
          powerPlantType: null,
          locationUsageType: null,
          installableAreaSquareMeter: null,
          ownershipStatus: null,
          applicantGoalFlags: 0,
          electricBoillNumber: "",
          installationType: "Villa",
          unitCount: null,
          needsLoan: false,
          nodeList: [
            { x: "", y: "" },
            { x: "", y: "" },
            { x: "", y: "" },
          ],
        };

        // برای create mode: استان‌ها، شهرها و enums هم‌زمان لود می‌شوند تا وقتی کاربر به مرحله انتخاب برسد دیتا آماده باشد
        if (params.id === "create") {
          const [provincesSettled, citiesSettled, enumsSettled] = await Promise.allSettled([
            CustomerRequestLocationService.getProvincesForCustomerRequest(),
            CustomerRequestLocationService.getCitiesForCustomerRequest(),
            DefaultApiService.getOneApi("SLN/Customer/Requests", 0),
          ]);

          const provincesResponse =
            provincesSettled.status === "fulfilled" ? provincesSettled.value : null;
          const citiesResponse =
            citiesSettled.status === "fulfilled" ? citiesSettled.value : null;
          if (provincesSettled.status === "rejected") {
            console.error("Error loading provinces:", provincesSettled.reason);
          }
          if (citiesSettled.status === "rejected") {
            console.error("Error loading cities:", citiesSettled.reason);
          }

          const provinces = CustomerRequestLocationService.mapProvincesToDropdown(provincesResponse);
          const cities = CustomerRequestLocationService.mapCitiesToDropdown(citiesResponse);

          const enumsResponse =
            enumsSettled.status === "fulfilled" ? enumsSettled.value : null;
          if (enumsSettled.status === "rejected") {
            console.error("Error loading enums:", enumsSettled.reason);
          }
          const enumData = unwrapCustomerRequestFormEnums(enumsResponse);

          return {
            request: defaultRequest,
            mode: "create",
            provinces,
            cities,
            plantKind: enumData.plantKind || enumData.PlantKind || [],
            agreementKind: enumData.agreementKind || enumData.AgreementKind || [],
            plantCapacity: resolvePlantCapacityOptions(enumsResponse),
          };
        }

        // برای edit mode: requestData، provinces و cities را موازی دریافت کن
        const [requestSettled, provincesSettled, citiesSettled] = await Promise.allSettled([
          DefaultApiService.getOneApi("SLN/Customer/Requests", params.id),
          CustomerRequestLocationService.getProvincesForCustomerRequest(),
          CustomerRequestLocationService.getCitiesForCustomerRequest(),
        ]);

        const provinces =
          provincesSettled.status === "fulfilled"
            ? CustomerRequestLocationService.mapProvincesToDropdown(provincesSettled.value)
            : [];
        const cities =
          citiesSettled.status === "fulfilled"
            ? CustomerRequestLocationService.mapCitiesToDropdown(citiesSettled.value)
            : [];

        const requestData =
          requestSettled.status === "fulfilled" ? requestSettled.value : null;
        const apiData = unwrapCustomerRequestFormEnums(requestData);
        const rawRequest = apiData?.request || apiData?.Request || apiData;
        const normalizedRequest = normalizeCustomerRequestForForm(rawRequest);

        return {
          request: { ...defaultRequest, ...normalizedRequest },
          mode: "edit",
          provinces,
          cities,
          plantKind: apiData?.plantKind || apiData?.PlantKind || [],
          agreementKind: apiData?.agreementKind || apiData?.AgreementKind || [],
          plantCapacity: resolvePlantCapacityOptions(requestData),
        };
      },
    },
    {
      path: "Customer/Requests/Information",
      element: <CustomerRequestsInfoPage />,
      loader: async (route) => {
        const url = new URL(route.request.url);
        const params = new URLSearchParams(url.search);

        return await loaderById({
          params: { id: params.get("id") },
          url: "SLN/Customer/InProcessRequest",
        });
      },
    },
    {
      path: "PaymentGateway/TestGateway",
      element: <TestGatewayPaymentPage />,
      handle: {
        title: "پرداخت",
        breadcrumb: "پرداخت",
        permissions: { view: true },
        url: "SLN/PaymentGateway/TestGateway",
      },
    },
    {
      path: "Customer/payment-result",
      element: <CustomerPaymentResultPage />,
      handle: {
        title: "نتیجه پرداخت",
        breadcrumb: "نتیجه پرداخت",
        permissions: { view: true },
        url: "SLN/Customer/payment-result",
      },
    },
    {
      path: "Customer/InvoicePayment/:invoiceId",
      element: <CustomerInvoicePaymentPage />,
      handle: {
        title: "پرداخت فاکتور",
        breadcrumb: "پرداخت فاکتور",
        permissions: { view: true },
        url: "SLN/Customer/InvoicePayment",
      },
    },
    {
      path: "Customer/Balance/TopUp",
      element: <CustomerBalanceTopUpPage />,
      handle: {
        title: "افزایش اعتبار پنل",
        breadcrumb: "افزایش اعتبار",
        permissions: { view: true },
        url: "SLN/Customer/Balance/TopUp",
      },
    },
    {
      path: "Customer/Balance/History",
      element: <CustomerBalanceHistoryPage />,
      handle: {
        title: "تاریخچه اعتبار پنل",
        breadcrumb: "تاریخچه اعتبار",
        permissions: { view: true },
        url: "SLN/Customer/Balance/History",
      },
    },
    {
      path: "Customer/FinancialReport",
      element: <FinancialReportPage />,
    },
    {
      path: "Customer/GenerationReport",
      element: <GenerationReportPage />,
    },
    {
      path: "Customer/TariffHistory",
      element: <TariffHistoryPage />,
    },
    {
      path: "Customer/Plants",
      element: <PlantsPage />,
    },
    {
      path: "Customer/ContractorSelection/:requestId",
      element: <ContractorSelectionPage />,
      loader: async ({ params }) => {
        return { requestId: params.requestId };
      },
    },
    // Operator
    {
      path: "SolarentOperator",
      element: <SolarentOperatorPage />,
    },
    {
      path: "SolarentOperator/LoanSimulator",
      element: <OperatorLoanSimulatorPage />,
      loader: async () =>
        await loaderDashboard({
          url: "SLN/SolarentOperator/LoanSimulator",
        }),
    },
    {
      path: "SolarentOperator/BankReconciliation",
      element: <BankReconciliationPage source="SolarentOperator" />,
    },
    {
      path: "SolarentOperator/GuaranteeChequeCustody",
      element: <GuaranteeChequeCustodyPage source="SolarentOperator" />,
    },
    {
      path: "SolarentOperator/ApplicantSms",
      element: <OperatorApplicantSmsPage />,
      loader: async () =>
        await loaderDashboard({
          url: "SLN/SolarentOperator/ApplicantSms",
        }),
    },

    {
      path: "SolarentOperator/Request",
      element: <SolarentOperatorRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/Request",
        }),
    },
    {
      path: "SolarentOperator/Request/:id",
      element: <ProjectWorkspaceRedirect configKey="solarentOperator" />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/Request",
        });
      },
    },
    {
      path: "SolarentOperator/ConsultationRequests",
      element: (
        <ConsultationRequestsPage
          api={consultationSolarentOperatorApi}
          operatorMode
        />
      ),
    },
    {
      path: "SolarentOperator/CustomerWithoutRequestLeads",
      element: (
        <CustomerWithoutRequestLeadsPage
          api={customerWithoutRequestLeadOperatorApi}
          operatorMode
        />
      ),
    },
    {
      path: "SolarentOperator/ExhibitionBoothLeads",
      element: (
        <ExhibitionBoothLeadsPage api={exhibitionBoothLeadOperatorApi} />
      ),
    },
    {
      path: "SolarentOperator/ContractorInfo",
      element: <SolarentOperatorContractorInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/ContractorInfo",
        }),
    },
    {
      path: "SolarentOperator/ContractorRegistration",
      element: <SolarentOperatorContractorRegistrationPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/ContractorRegistration",
        }),
    },
    {
      path: "SolarentOperator/ContractorRegistration/:id",
      element: <SolarentOperatorContractorRegistrationModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            contractorRegistration: {
              firstName: "",
              lastName: "",
              nationalCode: "",
              mobile: "",
              email: "",
              birthDate: "",
              companyName: "",
              companyRegistrationNumber: "",
              companyNationalId: "",
              companyPhone: "",
              companyAddress: "",
              city: "",
              province: "",
              postalCode: "",
              workExperience: "",
              foundedYear: 0,
              employeeCount: 0,
              nationalCardImageUrl: "",
              companyLicenseImageUrl: "",
              insuranceDocumentUrl: "",
              workSamplesUrls: [],
              status: 1,
              reviewNotes: "",
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/ContractorRegistration",
        });
      },
    },
    {
      path: "SolarentOperator/ContractorInfo/:id",
      element: <SolarentOperatorContractorInfoModifyPage />,
      loader: async ({ params }) => {
        const defaultContractorInfo = {
          id: 0,
          title: "",
          companyName: "",
          companyNationalId: "",
          companyRegistrationNumber: "",
          companyPhone: "",
          firstName: "",
          lastName: "",
          nationalCode: "",
          mobile: "",
          telephon: "",
          email: "",
          birthDate: "",
          provinceId: null,
          province: "",
          city: "",
          postalCode: "",
          address: "",
          workExperience: "",
          specialties: "",
          grade: 0,
          description: "",
          about: "",
          certificateUrl: "",
          insuranceDocumentUrl: "",
          nationalCardImageUrl: "",
          companyLicenseImageUrl: "",
          workSamplesUrls: "[]",
          contractorInfoStatus: "Pending",
          isActive: true,
          canPerformSiteVisit: false,
        };

        // For create mode
        if (params.id === "create") {
          return {
            contractorInfo: defaultContractorInfo,
            cityPermission: [],
            baseUrl: ""
          };
        }

        // For edit mode - fetch from API (returns ContractorInfoModel: { contractorInfo, cityPermission, baseUrl })
        try {
          const res = await DefaultApiService.getOneApi(
            "SLN/SolarentOperator/ContractorInfo",
            params.id
          );
          const apiData = res?.data?.data || res?.data || res;
          
          // apiData is already ContractorInfoModel with contractorInfo, cityPermission, baseUrl
          return {
            ...apiData,
            contractorInfo: { ...defaultContractorInfo, ...(apiData.contractorInfo || apiData) }
          };
        } catch (error) {
          console.error("Error loading contractor info:", error);
          return {
            contractorInfo: defaultContractorInfo,
            cityPermission: [],
            baseUrl: ""
          };
        }
      },
    },
    {
      path: "SolarentOperator/SupervisorInfo",
      element: <SolarentOperatorSupervisorInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/SupervisorInfo",
        }),
    },
    {
      path: "SolarentOperator/SupervisorInfo/:id",
      element: <SolarentOperatorSupervisorInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            supervisorInfo: {
              id: 0,
              userId: 0,
              companyId: 0,
              firstName: "",
              lastName: "",
              description: "",
              mobile: "",
              telephon: "",
              supervisorInfoStatus: "Pending",
              isActive: true,
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/SupervisorInfo",
        });
      },
    },

    {
      path: "SolarentOperator/SupplierInfo",
      element: <SolarentOperatorSupplierInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/SupplierInfo",
        }),
    },
    {
      path: "SolarentOperator/SupplierInfo/:id",
      element: <SolarentOperatorSupplierInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            supplierInfo: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/SupplierInfo",
        });
      },
    },
    {
      path: "SolarentOperator/ContractorProjectContract",
      element: <SolarentOperatorContractorProjectContractPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/ContractorProjectContract",
        }),
    },
    {
      path: "SolarentOperator/ContractorProjectContract/:id",
      element: <SolarentOperatorContractorProjectContractModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectContract: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/ContractorProjectContract",
        });
      },
    },
    {
      path: "SolarentOperator/SupplierProjectContract",
      element: <SolarentOperatorSupplierProjectContractPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/SupplierProjectContract",
        }),
    },
    {
      path: "SolarentOperator/SupplierProjectContract/:id",
      element: <SolarentOperatorSupplierProjectContractModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            supplierProjectContract: {
              id: 0,
              guid: "",
              requestId: 0,
              supplierInfoId: 0,
              title: "",
              price: 0,
              description: "",
              supplierProjectContractStatus: "Pending",
              startDateTime: "",
              endDateTime: "",
              isActive: true,
              customerFullName: "",
              projectTitle: "",
              projectCapacity: 0,
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/SupplierProjectContract",
        });
      },
    },
    {
      path: "SolarentOperator/ProjectWorkspace",
      element: <ProjectWorkspaceHubPage configKey="solarentOperator" />,
      loader: loaderProjectWorkspaceHub("solarentOperator"),
    },
    {
      path: "SolarentOperator/ProjectWorkspace/:id",
      element: <SolarentOperatorProjectWorkspacePage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: { id: 0, fullName: "", referenceID: 0 },
          },
          url: "SLN/SolarentOperator/AllRequests",
        });
      },
    },
    {
      path: "SolarentOperator/CheckNewRequest",
      element: <SolarentOperatorCheckNewRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/CheckNewRequest",
        }),
    },
    {
      path: "SolarentOperator/CheckNewRequest/:id",
      element: <SolarentOperatorCheckNewRequestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              stepInfoId: 0,
              referenceID: 0,
              plantKind: "IndividualBranching",
              xPoint: 0,
              yPoint: 0,
              powerPlantType: null,
              powerPlantTypeTitle: "ثبت نشده",
              locationUsageType: null,
              locationUsageTypeTitle: "ثبت نشده",
              installableAreaSquareMeter: null,
              ownershipStatus: null,
              ownershipStatusTitle: "ثبت نشده",
              applicantGoalFlags: null,
              applicantGoalsTitle: "ثبت نشده",
              note: "",
              requestConfirm: "NotChecked",
              adminComment: "",
              electricBoillUrl: "",
              extensionNumber: 0,
              sendSMS: true,
              postalCode: "",
              plantCapacity: "P5KW",
              plantCapacityTitle: "",
              isActive: true,

              address: "",
              firstName: "",
              lastName: "",
              mobile: "",
              telephon: "",
              companyId: 0,
              cityId: 0,
              substationId: 0,
              feederId: 0,
              userId: 0,
              companyName: "",
              cityName: "",
              substationName: "",
              feederName: "",
              stepTitle: "",
              agreementKind: "Real",
              agreementKindTitle: "",
              fatherName: "",
              birthDate: null,
              gender: "",
              customerInfoId: 0,
              requestConfirmTitle: "",
              fullName: "",
              plantKindTitle: "",
              electricBoillNumber: "",
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/CheckNewRequest",
        });
      },
    },
    {
      path: "SolarentOperator/ProjectFinalApproval",
      element: <SolarentOperatorProjectFinalApprovalPage />,
    },
    {
      path: "SolarentOperator/ProjectExecutionActivation",
      element: <SolarentOperatorProjectExecutionActivationPage />,
    },
    {
      path: "SolarentOperator/ProjectExecutionPlan",
      element: <SolarentOperatorProjectExecutionPlanPage />,
    },
    {
      path: "SolarentOperator/ProjectPaymentActivation",
      element: <SolarentOperatorProjectPaymentActivationPage />,
    },
    {
      path: "SolarentOperator/ProjectProcurementActivation",
      element: <SolarentOperatorProjectProcurementActivationPage />,
    },
    {
      path: "SolarentOperator/ProjectMilestoneCoordination",
      element: <SolarentOperatorProjectMilestoneCoordinationPage />,
    },
    {
      path: "SolarentOperator/InProcessRequest",
      element: <SolarentOperatorInProcessRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/InProcessRequest",
        }),
    },
    {
      path: "SolarentOperator/InProcessRequest/:id",
      element: <ProjectWorkspaceRedirect configKey="solarentOperator" />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/InProcessRequest",
        });
      },
    },
    {
      path: "SolarentOperator/AllRequests",
      element: <SolarentOperatorAllRequestsPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/AllRequests",
        }),
    },
    {
      path: "SolarentOperator/ApplicantContracts",
      element: <SolarentOperatorApplicantContractsPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/ApplicantContracts",
        }),
    },
    {
      path: "SolarentOperator/ApplicantContractFeeSettings",
      element: <SolarentOperatorApplicantContractFeeSettingsPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/ApplicantContractFeeSettings",
        }),
    },
    {
      path: "SolarentOperator/ApplicantRegistration",
      element: <SolarentOperatorApplicantRegistrationPage />,
    },
    {
      path: "SolarentOperator/InitialReviewFollowUp",
      element: <SolarentOperatorInitialReviewFollowUpPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/InitialReviewFollowUp",
        }),
    },
    {
      path: "SolarentOperator/AllRequests/:id",
      element: <ProjectWorkspaceRedirect configKey="solarentOperator" />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/AllRequests",
        });
      },
    },
    {
      path: "SolarentOperator/RejectedRequests/:id",
      element: <SolarentOperatorRejectedRequestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/SolarentOperator/RejectedRequests",
        });
      },
    },
    {
      path: "SolarentOperator/Request/Information",
      element: <SolarentOperatorRequestInfoPage />,
      loader: async (route) => {
        const url = new URL(route.request.url);
        const params = new URLSearchParams(url.search);

        return await loaderById({
          params: { id: params.get("id") },
          url: "SLN/SolarentOperator/Request",
        });
      },
    },

    {
      path: "SolarentOperator/RejectedRequests",
      element: <SolarentOperatorRejectedRequestsPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/SolarentOperator/RejectedRequests",
        }),
    },
    // Profile Approval
    {
      path: "SolarentOperator/ProfileApproval",
      element: <SolarentOperatorProfileApprovalPage />,
      loader: async () => {
        const res = await DefaultApiService.getApi(
          "SLN/SolarentOperator/ProfileApproval/GetPendingApprovalList"
        );
        return res?.data || [];
      },
    },
    {
      path: "SolarentOperator/ProfileApproval/:userId",
      element: <SolarentOperatorProfileApprovalDetailPage />,
      loader: async ({ params }) => {
        const res = await DefaultApiService.getApi(
          `SLN/SolarentOperator/ProfileApproval/GetProfileDetails/${params.userId}`
        );
        return res?.data || res;
      },
    },
    // Supervisor
    {
      path: "Supervisor",
      element: <SupervisorPage />,
      loader: async () =>
        await loaderDashboard({
          url: "SLN/Supervisor",
        }),
    },
    // Request

    {
      path: "Supervisor/SupervisorInfo",
      element: <SupervisorInfoPage />,
      loader: async () => {
        // هر ناظر فقط اطلاعات خودش را می‌بیند
        const result = await loaderGrid({
          url: "SLN/Supervisor/SupervisorInfo",
        });
        
        // فیلتر کردن اطلاعات برای نمایش فقط اطلاعات کاربر فعلی
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const currentUserId = user?.id || user?.userId;
        
        if (result && Array.isArray(result) && currentUserId) {
          // فقط اطلاعاتی که userId آن با کاربر فعلی برابر است را برگردان
          return result.filter(item => 
            item.userId === currentUserId || 
            Number(item.userId) === Number(currentUserId)
          );
        }
        
        return result;
      },
    },
    {
      path: "Supervisor/SupervisorInfo/:id",
      element: <SupervisorInfoModifyPage />,
      loader: async ({ params }) => {
        const result = await loaderById({
          params,
          initValue: {
            supervisorInfo: {
              userId: 0,
              companyInfoId: 0,
              description: "",
              mobile: "",
              telephon: "",
              supervisorInfoStatus: "Pending",
              isActive: true,
            },
            mode: "create",
          },
          url: "SLN/Supervisor/SupervisorInfo",
        });
        
        // اگر در حالت ویرایش است، بررسی کنیم که کاربر فقط اطلاعات خودش را ویرایش کند
        if (params.id !== "create" && result?.supervisorInfo) {
          const user = JSON.parse(localStorage.getItem("user") || "{}");
          const currentUserId = user?.id || user?.userId;
          const supervisorUserId = result.supervisorInfo?.userId;
          
          // اگر userId اطلاعات با کاربر فعلی برابر نیست، دسترسی غیرمجاز است
          if (currentUserId && supervisorUserId && 
              Number(supervisorUserId) !== Number(currentUserId)) {
            throw new Response("شما فقط مجاز به مشاهده و ویرایش اطلاعات خود هستید", { 
              status: 403,
              statusText: "Forbidden" 
            });
          }
        }
        
        return result;
      },
    },

    {
      path: "Supervisor/ProjectDesign",
      element: <SupervisorProjectDesignPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/ProjectDesign",
        }),
    },
    {
      path: "Supervisor/ProjectDesign/:id",
      element: <SupervisorProjectDesignModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectDesign: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/Supervisor/ProjectDesign",
        });
      },
    },
    {
      path: "Supervisor/ProjectTest",
      element: <SupervisorProjectTestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/ProjectTest",
        }),
    },
    {
      path: "Supervisor/ProjectTest/:id",
      element: <SupervisorProjectTestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectTest: {
              requestId: 0,
              contractorInfoId: 0,
              description: "",
              testResult: "",
              companyId: 0,
              projectTestStatus: "Pending",
            },
            mode: "create",
          },
          url: "SLN/Supervisor/ProjectTest",
        });
      },
    },
    {
      path: "Supervisor/OperationLicense",
      element: <SupervisorOperationLicensePage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/OperationLicense",
        }),
    },
    {
      path: "Supervisor/OperationLicense/:id",
      element: <SupervisorOperationLicenseModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            operationLicense: {
              requestId: 0,
              contractorInfoId: 0,
              companyId: 0,
              title: "",
              licenseFileUrl: "",
              description: "",
              testResult: "",
              operationLicenseStatus: "Pending",
            },
            mode: "create",
          },
          url: "SLN/Supervisor/OperationLicense",
        });
      },
    },
    {
      path: "Supervisor/ProjectExecutionSchedule",
      element: <SupervisorProjectExecutionSchedulePage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/ProjectExecutionSchedule",
        }),
    },
    {
      path: "Supervisor/ProjectExecutionSchedule/:id",
      element: <SupervisorProjectExecutionScheduleModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectExecutionSchedule: {
              requestId: 0,
              contractorInfoId: 0,
              description: "",
              executionScheduleApprovalStatus: "Pending",
              mountStructureInstallationStartDateTime: "",
              mountStructureInstallationEndDateTime: "",
              dcElectricalInstallationStartDateTime: "",
              dcElectricalInstallationEndDateTime: "",
              acElectricalInstallationStartDateTime: "",
              acElectricalInstallationEndDateTime: "",
              initialCommissioningStartDateTime: "",
              initialCommissioningEndDateTime: "",
              companyId: 0,
            },
            mode: "create",
          },
          url: "SLN/Supervisor/ProjectExecutionSchedule",
        });
      },
    },
    {
      path: "Supervisor/ProjectPlantConstruction",
      element: <SupervisorProjectPlantConstructionPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/ProjectPlantConstruction",
        }),
    },
    {
      path: "Supervisor/ProjectPlantConstruction/:id",
      element: <SupervisorProjectPlantConstructionModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectPlantConstruction: {
              requestId: 0,
              contractorInfoId: 0,
              description: "",
              mountStructureInstallation: true,
              dcElectricalInstallation: true,
              acElectricalInstallation: true,
              initialCommissioning: true,
              projectPlantConstructionStatus: "Pending",
              companyId: 0,
            },
            mode: "create",
          },
          url: "SLN/Supervisor/ProjectPlantConstruction",
        });
      },
    },
    {
      path: "Supervisor/ProjectGridConnection",
      element: <SupervisorProjectGridConnectionPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/ProjectGridConnection",
        }),
    },
    {
      path: "Supervisor/InstalledEquipment",
      element: <SupervisorInstalledEquipmentPage />,
    },
    {
      path: "Supervisor/ProjectGridConnection/:id",
      element: <SupervisorProjectGridConnectionModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectGridConnection: {
              requestId: 0,
              contractorInfoId: 0,
              companyId: 0,
              description: "",
              projectGridConnectionFileUrl: "",
              projectGridConnectionStatus: "Pending",
            },
            mode: "create",
          },
          url: "SLN/Supervisor/ProjectGridConnection",
        });
      },
    },

    {
      path: "Supervisor/ContractorProjectContract",
      element: <SupervisorContractorProjectContractPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/ContractorProjectContract",
        }),
    },
    {
      path: "Supervisor/ContractorProjectContract/:id",
      element: <SupervisorContractorProjectContractModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectContract: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/Supervisor/ContractorProjectContract",
        });
      },
    },

    {
      path: "Supervisor/PowerPurchaseAgreement",
      element: <PowerPurchaseAgreementPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/PowerPurchaseAgreement",
        }),
    },
    {
      path: "Supervisor/PowerPurchaseAgreement/:id",
      element: <PowerPurchaseAgreementModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            powerPurchaseAgreement: {
              requestId: 0,
              supervisorInfoId: 0,
              customerInfoId: 0,
              userId: 0,
              title: "",
              description: "",
              contractFileUrl: "",
              powerPurchaseAgreementStatus: "Pending",
              startDateTime: "",
              endDateTime: "",
              actualEndDateTime: "",
              isActive: true,
              customerFullName: "",
            },
            mode: "create",
          },
          url: "SLN/Supervisor/PowerPurchaseAgreement",
        });
      },
    },
    {
      path: "Supervisor/SiteVisit",
      element: <SiteVisitPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/SiteVisit",
        }),
    },
    {
      path: "Supervisor/ProjectAssignments/Closed",
      element: <SupervisorProjectAssignmentsPage />,
    },
    {
      path: "Supervisor/ProjectAssignments",
      element: <SupervisorProjectAssignmentsPage />,
    },
    // Menu aliases: RequestList → پروژه‌های جاری; Closed → پروژه‌های قبلی
    {
      path: "Supervisor/RequestList/ProjectAssignments/Closed",
      element: <SupervisorProjectAssignmentsPage />,
    },
    {
      path: "Supervisor/RequestList/ProjectAssignments",
      element: <SupervisorProjectAssignmentsPage />,
    },
    {
      path: "Supervisor/RequestList",
      element: <SupervisorProjectAssignmentsPage />,
    },
    {
      path: "Supervisor/ExecutionMilestones",
      element: <SupervisorExecutionMilestonesPage />,
    },
    {
      path: "Supervisor/SiteVisit/:id",
      element: <SiteVisitModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            siteVisit: {
              userId: 0,
              requestId: 0,
              companyId: 0,
              requestedCapacity: 0,
              proposedCapacity: 0,
              amper: 0,
              phaseCount: "SinglePhase",
              billId: "",
              subscriptionNumber: "",
              isSharedRooftop: true,
              hasMeterLocation: true,
              isBuildingUnder10Yrs: true,
              isFullSunlight: true,
              isSubscriptionVerified: true,
              isVisitedByDistributionCompanySupervisor: false,
              installationLocationType: "",
              installationLocationOther: "",
              description: "",
              attachedFileUrl: "",
              siteVisitStatus: "Pending",
              scheduledVisitTime: "",
              actualVisitTime: "",
              fullName: "",
              companyName: "",
              requestTitle: "",
            },
            mode: "create",
          },
          url: "SLN/Supervisor/SiteVisit",
        });
      },
    },
    {
      path: "Supervisor/Request",
      element: <SupervisorRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/Request",
        }),
    },
    {
      path: "Supervisor/Request/:id",
      element: <SupervisorRequestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/Supervisor/Request",
        });
      },
    },

    {
      path: "Supervisor/InProcessRequest",
      element: <SupervisorProjectAssignmentsPage />,
    },
    {
      path: "Supervisor/InProcessRequest/:id",
      element: <SupervisorInProcessRequestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/Supervisor/InProcessRequest",
        });
      },
    },
    {
      path: "Supervisor/RejectedRequests/:id",
      element: <SupervisorRejectedRequestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/Supervisor/RejectedRequests",
        });
      },
    },
    {
      path: "Supervisor/Request/Information",
      element: <SupervisorRequestInfoPage />,
      loader: async (route) => {
        const url = new URL(route.request.url);
        const params = new URLSearchParams(url.search);

        return await loaderById({
          params: { id: params.get("id") },
          url: "SLN/Supervisor/Request",
        });
      },
    },

    {
      path: "Supervisor/RejectedRequests",
      element: <SupervisorRejectedRequestsPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Supervisor/RejectedRequests",
        }),
    },
    // Contractor — portal lives at /SLN/Contractor (see contractorPortalSlnRouteEntries)
    // Legacy operational pages remain under /SLN/Contractor/*

    {
      path: "Contractor/ContractorInfo",
      element: <ContractorInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/ContractorInfo",
        }),
    },
    {
      path: "Contractor/ContractorInfo/:id",
      element: <ContractorInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            contractorInfo: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              email: "",
              about: "",
              address: "",
              provinceId: null,
              province: "",
              city: "",
              postalCode: "",
              firstName: "",
              lastName: "",
              nationalCode: "",
              companyNationalId: "",
              companyRegistrationNumber: "",
              companyPhone: "",
              workExperience: "",
              specialties: "[]",
              nationalCardImageUrl: "",
              companyLicenseImageUrl: "",
              insuranceDocumentUrl: "",
              certificateUrl: "",
            },
            registration: null,
            isReadOnly: false,
            mode: "create",
          },
          url: "SLN/Contractor/ContractorInfo",
        });
      },
    },

    {
      path: "Contractor/ProjectWorkspace",
      element: <ContractorProjectWorkspaceRedirect />,
    },
    {
      path: "Contractor/ProjectWorkspace/:id",
      element: <ContractorProjectWorkspaceRedirect />,
    },
    {
      path: "Contractor/InProcessRequest",
      element: <ContractorInProcessRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/InProcessRequest",
        }),
    },
    {
      path: "Contractor/InProcessRequest/:id",
      element: <ContractorInProcessRequestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              projectOwnerFirstName: "",
              projectOwnerLastName: "",
              projectOwnerMobile: "",
              projectOwnerTelephon: "",
              projectOwnerEmail: "",
              projectOwnerAddress: "",
              projectTitle: "",
              projectAddress: "",
              agreementKind: "Real",
              projectCapacity: "",
              satbaOrCHPReferenceId: "",
              projectKind: "",
              xPoint: "",
              yPoint: "",
              requestConfirm: "",
              isActive: true,
              note: "",
              uploadedFileUrl: "",
              companyNationalCode: "",
              companyRegisterationCode: "",
              postalCode: "",
              feederZone: "",
              nodeList: [
                { x: "", y: "" },
                { x: "", y: "" },
                { x: "", y: "" },
              ],
            },
            mode: "create",
          },
          url: "SLN/Contractor/InProcessRequest",
        });
      },
    },
    {
      path: "Contractor/ProjectContractChecking",
      element: <ProjectContractCheckingPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/ProjectContractChecking",
        }),
    },
    {
      path: "Contractor/ProjectContractChecking/:id",
      element: <ProjectContractCheckingModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectContract: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/Contractor/ProjectContractChecking",
        });
      },
    },
    {
      path: "Contractor/ProjectDesign",
      element: <ContractorProjectDesignPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/ProjectDesign",
        }),
    },
    {
      path: "Contractor/ProjectDesign/:id",
      element: <ContractorProjectDesignModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectDesign: {
              title: "",
              description: "",
              mobile: "",
              telephon: "",
              about: "",
              address: "",
              certificateUrl: "",
            },
            mode: "create",
          },
          url: "SLN/Contractor/ProjectDesign",
        });
      },
    },
    {
      path: "Contractor/ProjectTest",
      element: <ContractorProjectTestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/ProjectTest",
        }),
    },
    {
      path: "Contractor/ProjectTest/:id",
      element: <ContractorProjectTestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectTest: {
              requestId: 0,
              contractorInfoId: 0,
              description: "",
              testResult: "",
              companyId: 0,
              projectTestStatus: "Pending",
            },
            mode: "create",
          },
          url: "SLN/Contractor/ProjectTest",
        });
      },
    },
    {
      path: "Contractor/ContractorReferral",
      element: <ContractorReferralPage />,
    },
    {
      path: "Contractor/ContractorReferralLeads",
      element: <ContractorReferralLeadsPage />,
    },
    {
      path: "Contractor/AssistedRegistration",
      element: (
        <RoleGuardRoute requireContractorAssistedRegistration>
          <ContractorAssistedRegistrationPage />
        </RoleGuardRoute>
      ),
    },
    {
      path: "Contractor/Team",
      element: <ContractorTeamPage />,
    },
    {
      path: "Contractor/PackageManagement",
      element: <ContractorPackageManagementPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/PackageManagement",
        }),
    },
    {
      path: "Contractor/EquipmentItemRequests",
      element: <ContractorEquipmentItemRequestsPage />,
    },
    {
      path: "Contractor/PackageManagement/:id",
      element: <ContractorPackageModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            package: {
              title: "",
              capacityType: "",
              capacity: 0,
              price: 0,
              discountPercent: 0,
              description: "",
              equipments: [],
              features: [],
            },
            plantCapacity: [],
            mode: "create",
          },
          url: "SLN/Contractor/PackageManagement",
        });
      },
    },
    {
      path: "Contractor/ProjectExecutionSchedule",
      element: <ContractorProjectExecutionSchedulePage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/ProjectExecutionSchedule",
        }),
    },
    {
      path: "Contractor/ProjectExecutionSchedule/:id",
      element: <ContractorProjectExecutionScheduleModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectExecutionSchedule: {
              requestId: 0,
              contractorInfoId: 0,
              description: "",
              mountStructureInstallationStartDateTime: "",
              mountStructureInstallationEndDateTime: "",
              dcElectricalInstallationStartDateTime: "",
              dcElectricalInstallationEndDateTime: "",
              acElectricalInstallationStartDateTime: "",
              acElectricalInstallationEndDateTime: "",
              initialCommissioningStartDateTime: "",
              initialCommissioningEndDateTime: "",
              companyId: 0,
            },
            mode: "create",
          },
          url: "SLN/Contractor/ProjectExecutionSchedule",
        });
      },
    },
    {
      path: "Contractor/ProjectPlantConstruction",
      element: <ContractorProjectPlantConstructionPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/ProjectPlantConstruction",
        }),
    },
    {
      path: "Contractor/ProjectPlantConstruction/:id",
      element: <ContractorProjectPlantConstructionModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectPlantConstruction: {
              requestId: 0,
              contractorInfoId: 0,
              description: "",
              mountStructureInstallation: true,
              dcElectricalInstallation: true,
              acElectricalInstallation: true,
              initialCommissioning: true,
              projectPlantConstructionStatus: "Pending",
              companyId: 0,
            },
            mode: "create",
          },
          url: "SLN/Contractor/ProjectPlantConstruction",
        });
      },
    },
    {
      path: "Contractor/ProjectGridConnection",
      element: <ContractorProjectGridConnectionPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/ProjectGridConnection",
        }),
    },
    {
      path: "Contractor/ProjectGridConnection/:id",
      element: <ContractorProjectGridConnectionModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            projectGridConnection: {
              requestId: 0,
              contractorInfoId: 0,
              companyId: 0,
              description: "",
              projectGridConnectionFileUrl: "",
              projectGridConnectionStatus: "Pending",
            },
            mode: "create",
          },
          url: "SLN/Contractor/ProjectGridConnection",
        });
      },
    },
    {
      path: "Contractor/SiteVisit",
      element: <ContractorSiteVisitPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Contractor/SiteVisit",
        }),
    },
    {
      path: "Contractor/ProjectAssignments/Closed",
      element: <ContractorProjectAssignmentsPage />,
    },
    {
      path: "Contractor/ProjectAssignments",
      element: <ContractorProjectAssignmentsPage />,
    },
    {
      path: "Contractor/ExecutionMilestones",
      element: <ContractorExecutionMilestonesPage />,
    },
    {
      path: "Contractor/ProjectQuotes",
      element: <ContractorProjectQuotesPage />,
    },
    {
      path: "Contractor/ProjectContractAcceptance",
      element: <ContractorProjectContractAcceptancePage />,
    },
    {
      path: "Contractor/SiteVisit/:id",
      element: <ContractorSiteVisitModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            siteVisit: {
              requestId: 0,
              requestedCapacity: "",
              proposedCapacity: "",
              amper: "",
              billId: "",
              subscriptionNumber: "",
              computerPassword: "",
              scheduledVisitTime: "",
              actualVisitTime: "",
              phaseCount: "",
              isSharedRooftop: false,
              hasMeterLocation: false,
              isBuildingUnder10Yrs: false,
              isFullSunlight: false,
              isSubscriptionVerified: false,
              isVisitedByDistributionCompanySupervisor: false,
              installationLocationType: "",
              installationLocationOther: "",
              description: "",
              siteVisitStatus: "Pending",
            },
            phaseCount: [],
            siteVisitStatus: [],
            mode: "create",
          },
          url: "SLN/Contractor/SiteVisit",
        });
      },
    },
    // Management Dashboard
    {
      path: "Management",
      element: <SLNManagementPage />,
      loader: async () =>
        await loaderDashboard({
          url: "SLN/Management",
        }),
    },
    {
      path: "Management/CustomerInfo",
      element: <CustomerInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/CustomerInfo",
        }),
    },
    {
      path: "Management/CustomerInfo/:id",
      element: <CustomerInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            customerInfo: {
              title: "",
              adminAlertText: "",
              customerAlertText: "",
              stepDescription: "",
              daysRequired: "",
              priority: "",
              isActive: true,
            },
          },
          url: "SLN/Management/CustomerInfo",
        });
      },
    },

    {
      path: "Management/ContractorInfo",
      element: <ManagementContractorInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/ContractorInfo",
        }),
    },
    {
      path: "Management/EquipmentMasterCatalog",
      element: <EquipmentMasterCatalogPage />,
    },
    {
      path: "Management/EquipmentMasterCatalog/create",
      element: <EquipmentMasterCatalogModify />,
    },
    {
      path: "Management/EquipmentMasterCatalog/:id",
      element: <EquipmentMasterCatalogModify />,
    },
    {
      path: "Management/DistributionNetwork",
      element: <DistributionNetworkExplorerPage />,
    },
    {
      path: "Management/DistributionCompanies",
      element: <DistributionCompaniesPage />,
    },
    {
      path: "Management/DistributionCompanies/create",
      element: <DistributionCompanyModifyPage />,
    },
    {
      path: "Management/DistributionCompanies/:id",
      element: <DistributionCompanyModifyPage />,
    },
    {
      path: "Management/DistributionAreas",
      element: <DistributionAreasPage />,
    },
    {
      path: "Management/DistributionAreas/create",
      element: <DistributionAreaModifyPage />,
    },
    {
      path: "Management/DistributionAreas/:id",
      element: <DistributionAreaModifyPage />,
    },
    {
      path: "Management/DistributionContacts",
      element: <DistributionContactsPage />,
    },
    {
      path: "Management/DistributionContacts/create",
      element: <DistributionContactModifyPage />,
    },
    {
      path: "Management/DistributionContacts/:id",
      element: <DistributionContactModifyPage />,
    },
    {
      path: "Management/SalesProforma",
      element: <ManagementSalesProformaPage />,
    },
    {
      path: "Management/EquipmentCategories",
      element: <EquipmentCategoryManagement />,
    },
    {
      path: "Management/EquipmentBrands",
      element: <EquipmentBrandManagement />,
    },
    {
      path: "Management/EquipmentItemRequests",
      element: <EquipmentItemRequests />,
    },
    {
      path: "Management/ContractorReferralReport",
      element: <ManagementContractorReferralReportPage />,
    },
    {
      path: "Management/ContractorReferralLeads",
      element: <ManagementContractorReferralReportPage />,
    },
    {
      path: "Management/ContractorInfo/Information",
      element: <ManagementContractorInfoInformationPage />,
      loader: async ({ request }) => {
        const url = new URL(request.url);
        const id = url.searchParams.get("id");

        if (!id) {
          return {
            contractorInfo: null,
            cityPermission: [],
            baseUrl: "",
            mode: "view",
            errorMessage: "شناسه پیمانکار مشخص نشده است.",
          };
        }

        try {
          const response = await DefaultApiService.getOneApi(
            "SLN/Management/ContractorInfo",
            id
          );

          const isSuccess = response?.isSuccess ?? response?.IsSuccess;
          const apiData = response?.data ?? response?.Data ?? null;

          if (!isSuccess || !apiData) {
            return {
              contractorInfo: null,
              cityPermission: [],
              baseUrl: "",
              mode: "view",
              errorMessage:
                response?.message ||
                response?.Message ||
                "اطلاعات پیمانکار یافت نشد.",
            };
          }

          // API returns ContractorInfoModel: { contractorInfo, cityPermission, baseUrl }
          const contractorInfo =
            apiData.contractorInfo ||
            apiData.ContractorInfo ||
            (apiData.id || apiData.Id ? apiData : null);

          if (!contractorInfo) {
            return {
              contractorInfo: null,
              cityPermission: apiData.cityPermission || apiData.CityPermission || [],
              baseUrl: apiData.baseUrl || apiData.BaseUrl || "",
              mode: "view",
              errorMessage: "اطلاعات پیمانکار یافت نشد.",
            };
          }

          return {
            contractorInfo,
            cityPermission: apiData.cityPermission || apiData.CityPermission || [],
            baseUrl: apiData.baseUrl || apiData.BaseUrl || "",
            mode: "view",
          };
        } catch (error) {
          console.error("Error loading ContractorInfo:", error);
          return {
            contractorInfo: null,
            cityPermission: [],
            baseUrl: "",
            mode: "view",
            errorMessage: "خطا در بارگذاری اطلاعات پیمانکار.",
          };
        }
      },
    },
    {
      path: "Management/ContractorInfo/:id",
      element: <ManagementContractorInfoModifyPage />,
      loader: async ({ params }) => {
        const defaultContractorInfo = {
          id: 0,
          title: "",
          companyName: "",
          companyNationalId: "",
          companyRegistrationNumber: "",
          companyPhone: "",
          firstName: "",
          lastName: "",
          nationalCode: "",
          mobile: "",
          telephon: "",
          email: "",
          birthDate: "",
          provinceId: null,
          province: "",
          city: "",
          postalCode: "",
          address: "",
          workExperience: "",
          specialties: "",
          grade: 0,
          description: "",
          about: "",
          certificateUrl: "",
          insuranceDocumentUrl: "",
          nationalCardImageUrl: "",
          companyLicenseImageUrl: "",
          workSamplesUrls: "[]",
          contractorInfoStatus: "Pending",
          isActive: true,
          canPerformSiteVisit: false,
        };

        // For create mode
        if (params.id === "create") {
          return {
            contractorInfo: defaultContractorInfo,
            cityPermission: [],
            baseUrl: ""
          };
        }

        // For edit mode - fetch from API (returns ContractorInfoModel: { contractorInfo, cityPermission, baseUrl })
        try {
          const res = await DefaultApiService.getOneApi(
            "SLN/Management/ContractorInfo",
            params.id
          );
          const apiData = res?.data?.data || res?.data || res;
          
          // apiData is already ContractorInfoModel with contractorInfo, cityPermission, baseUrl
          return {
            ...apiData,
            contractorInfo: { ...defaultContractorInfo, ...(apiData.contractorInfo || apiData) }
          };
        } catch (error) {
          console.error("Error loading contractor info:", error);
          return {
            contractorInfo: defaultContractorInfo,
            cityPermission: [],
            baseUrl: ""
          };
        }
      },
    },

    // Contractor Registration - ثبت‌نام و بررسی درخواست‌های پیمانکاران
    {
      path: "Management/ContractorRegistration",
      element: <ManagementContractorRegistrationPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/ContractorRegistration",
        }),
    },
    {
      path: "Management/ContractorRegistration/:id",
      element: <ManagementContractorRegistrationModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            contractorRegistration: {
              firstName: "",
              lastName: "",
              nationalCode: "",
              mobile: "",
              email: "",
              birthDate: "",
              companyName: "",
              companyRegistrationNumber: "",
              companyNationalId: "",
              companyPhone: "",
              companyAddress: "",
              city: "",
              province: "",
              postalCode: "",
              workExperience: "",
              foundedYear: 0,
              employeeCount: 0,
              nationalCardImageUrl: "",
              companyLicenseImageUrl: "",
              insuranceDocumentUrl: "",
              workSamplesUrls: [],
              status: 1,
              reviewNotes: "",
            },
            mode: "create",
          },
          url: "SLN/Management/ContractorRegistration",
        });
      },
    },
    {
      path: "Management/ContractorMasterContract",
      element: <ContractorMasterContractOperatorPage />,
    },
    // Legacy routes for backward compatibility
    {
      path: "Management/ContractorRegistrationReview",
      element: <ManagementContractorRegistrationPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/ContractorRegistration",
        }),
    },
    {
      path: "Management/ContractorRegistrationReview/:id",
      element: <ManagementContractorRegistrationModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            contractorRegistration: {
              firstName: "",
              lastName: "",
              nationalCode: "",
              mobile: "",
              email: "",
              birthDate: "",
              companyName: "",
              companyRegistrationNumber: "",
              companyNationalId: "",
              companyPhone: "",
              companyAddress: "",
              city: "",
              province: "",
              postalCode: "",
              workExperience: "",
              foundedYear: 0,
              employeeCount: 0,
              nationalCardImageUrl: "",
              companyLicenseImageUrl: "",
              insuranceDocumentUrl: "",
              workSamplesUrls: [],
              status: 1,
              reviewNotes: "",
            },
            mode: "create",
          },
          url: "SLN/Management/ContractorRegistration",
        });
      },
    },

    {
      path: "Management/ConsultationRequests",
      element: <ConsultationRequestsPage />,
    },
    {
      path: "Management/CustomerWithoutRequestLeads",
      element: <CustomerWithoutRequestLeadsPage />,
    },
    {
      path: "Management/ExhibitionBoothLeads",
      element: <ExhibitionBoothLeadsPage />,
    },
    {
      path: "Management/ConsultationSettings",
      element: <ConsultationSettingsPage />,
    },
    {
      path: "Management/BankReconciliation",
      element: <BankReconciliationPage source="Management" />,
    },
    {
      path: "Management/GuaranteeChequeCustody",
      element: <GuaranteeChequeCustodyPage source="Management" />,
    },
    {
      path: "Management/WarehouseSlips",
      element: <WarehouseSlipsPage source="Management" />,
    },
    {
      path: "SolarentOperator/WarehouseSlips",
      element: <WarehouseSlipsPage source="SolarentOperator" />,
    },
    {
      path: "Management/WarehouseChecking",
      element: <WarehouseCheckingPage source="Management" />,
    },
    {
      path: "SolarentOperator/WarehouseChecking",
      element: <WarehouseCheckingPage source="SolarentOperator" />,
    },

    // IndividualBranchingStepInfo
    {
      path: "Management/IndividualBranchingStepInfo",
      element: <IndividualBranchingStepInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/IndividualBranchingStepInfo",
        }),
    },
    {
      path: "Management/IndividualBranchingStepInfo/:id",
      element: <IndividualBranchingStepInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            stepInfo: {
              title: "",
              adminAlertText: "",
              customerAlertText: "",
              stepDescription: "",
              daysRequired: "",
              priority: "",
              isActive: true,
            },
          },
          url: "SLN/Management/IndividualBranchingStepInfo",
        });
      },
    },
    // IndividualNonSplitStepInfo
    {
      path: "Management/IndividualNonSplitStepInfo",
      element: <IndividualNonSplitStepInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/IndividualNonSplitStepInfo",
        }),
    },
    {
      path: "Management/IndividualNonSplitStepInfo/:id",
      element: <IndividualNonSplitStepInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            stepInfo: {
              title: "",
              adminAlertText: "",
              customerAlertText: "",
              stepDescription: "",
              daysRequired: "",
              priority: "",
              isActive: true,
            },
          },
          url: "SLN/Management/IndividualNonSplitStepInfo",
        });
      },
    },
    // Below200KWStepInfo
    {
      path: "Management/Below200KWStepInfo",
      element: <Below200KWStepInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/Below200KWStepInfo",
        }),
    },
    {
      path: "Management/Below200KWStepInfo/:id",
      element: <Below200KWStepInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            title: "",
            adminAlertText: "",
            customerAlertText: "",
            stepDescription: "",
            daysRequired: "",
            priority: "",
            isActive: true,
          },
          url: "SLN/Management/Below200KWStepInfo",
        });
      },
    },
    // GasStepInfo
    {
      path: "Management/GasStepInfo",
      element: <GasStepInfoPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/GasStepInfo",
        }),
    },
    {
      path: "Management/GasStepInfo/:id",
      element: <GasStepInfoModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            title: "",
            adminAlertText: "",
            customerAlertText: "",
            stepDescription: "",
            daysRequired: "",
            priority: "",
            isActive: true,
          },
          url: "SLN/Management/GasStepInfo",
        });
      },
    },
    {
      path: "Management/AllRequest",
      element: <ManagementAllRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/AllRequest",
        }),
    },
    {
      path: "Management/ProjectWorkspace",
      element: <ProjectWorkspaceHubPage configKey="management" />,
      loader: loaderProjectWorkspaceHub("management"),
    },
    {
      path: "Management/ProjectWorkspace/:id",
      element: <ManagementProjectWorkspacePage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: { id: 0, fullName: "", referenceID: 0 },
          },
          url: "SLN/Management/AllRequest",
        });
      },
    },
    // CheckNewRequest
    {
      path: "Management/CheckNewRequest",
      element: <CheckNewRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/CheckNewRequest",
        }),
    },
    {
      path: "Management/CheckNewRequest/:id",
      element: <CheckNewRequestModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            request: {
              stepInfoId: 0,
              referenceID: 0,
              plantKind: "IndividualBranching",
              xPoint: 0,
              yPoint: 0,
              powerPlantType: null,
              powerPlantTypeTitle: "ثبت نشده",
              locationUsageType: null,
              locationUsageTypeTitle: "ثبت نشده",
              installableAreaSquareMeter: null,
              ownershipStatus: null,
              ownershipStatusTitle: "ثبت نشده",
              applicantGoalFlags: null,
              applicantGoalsTitle: "ثبت نشده",
              note: "",
              requestConfirm: "NotChecked",
              adminComment: "",
              electricBoillUrl: "",
              extensionNumber: 0,
              sendSMS: true,
              postalCode: "",
              plantCapacity: "P5KW",
              plantCapacityTitle: "",
              isActive: true,
              address: "",
              firstName: "",
              lastName: "",
              mobile: "",
              telephon: "",
              companyId: 0,
              cityId: 0,
              substationId: 0,
              feederId: 0,
              userId: 0,
              companyName: "",
              cityName: "",
              substationName: "",
              feederName: "",
              stepTitle: "",
              agreementKind: "Real",
              agreementKindTitle: "",
              fatherName: "",
              birthDate: null,
              gender: "",
              customerInfoId: 0,
              requestConfirmTitle: "",
              fullName: "",
              plantKindTitle: "",
              electricBoillNumber: "",
            },
            mode: "create",
          },
          url: "SLN/Management/CheckNewRequest",
        });
      },
    },
    {
      path: "Management/ProjectFinalApproval",
      element: <ManagementProjectFinalApprovalPage />,
    },
    {
      path: "Management/ProjectExecutionActivation",
      element: <ManagementProjectExecutionActivationPage />,
    },
    {
      path: "Management/ProjectExecutionPlan",
      element: <ManagementProjectExecutionPlanPage />,
    },
    {
      path: "Management/ProjectPaymentActivation",
      element: <ManagementProjectPaymentActivationPage />,
    },
    {
      path: "Management/ProjectProcurementActivation",
      element: <ManagementProjectProcurementActivationPage />,
    },
    {
      path: "Management/ProjectMilestoneCoordination",
      element: <ManagementProjectMilestoneCoordinationPage />,
    },
    // InProcessRequest
    {
      path: "Management/CompletedRequest",
      element: <CompletedRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/CompletedRequest",
        }),
    },
    {
      path: "Management/InProcessRequest",
      element: <InProcessRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/InProcessRequest",
        }),
    },
    {
      path: "Management/InitialReviewFollowUp",
      element: <ManagementInitialReviewFollowUpPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/InitialReviewFollowUp",
        }),
    },
    {
      path: "Management/RejectedRequests",
      element: <RejectedRequestsPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/RejectedRequests",
        }),
    },
    {
      path: "Management/DeleteRequest",
      element: <DeleteRequestPage />,
      loader: async () =>
        await loaderGrid({
          url: "SLN/Management/DeleteRequest",
        }),
    },
    {
      path: "Management/SendGroupSMS",
      element: <SendGroupSMSPage />,
      loader: async () =>
        await loaderReport({
          url: "SLN/Management/SendGroupSMS",
        }),
    },
    {
      path: "Management/StationSearch",
      element: <StationSearchPage />,
      loader: async () =>
        await loaderReport({
          url: "SLN/Management/StationSearch",
        }),
    },
    {
      path: "Management/ComprehensiveReport",
      element: <ComprehensiveReportPage />,
      loader: async () =>
        await loaderReport({
          url: "SLN/Management/ComprehensiveReport",
        }),
    },
    {
      path: "Management/FeederAvailableCapacitiesReport",
      element: <FeederAvailableCapacitiesReportPage />,
      loader: async () =>
        await loaderReport({
          url: "SLN/Management/FeederAvailableCapacitiesReport",
        }),
    },
    {
      path: "Management/InProcessRequest/:id",
      element: <ProjectWorkspaceRedirect configKey="management" />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          url: "SLN/Management/InProcessRequest",
        });
      },
    },
    {
      path: "Management/Map",
      element: <MapReportPage />,
    },
    // Profile Approval
    {
      path: "Management/ProfileApproval",
      element: <ProfileApprovalPage />,
      loader: async () => {
        const res = await DefaultApiService.getApi(
          "SLN/Management/ProfileApproval/GetPendingApprovalList"
        );
        return res?.data || [];
      },
    },
    {
      path: "Management/ProfileApproval/:userId",
      element: <ProfileApprovalDetailPage />,
      loader: async ({ params }) => {
        const res = await DefaultApiService.getApi(
          `SLN/Management/ProfileApproval/GetProfileDetails/${params.userId}`
        );
        return res?.data || res;
      },
    },

    // ==================== Tickets ================================================
    {
      path: "Tickets",
      element: <TicketsListPage />,
    },
    {
      path: "Tickets/Detail/:ticketId",
      element: <TicketDetailPage />,
    },

    // ==================== SMS Reports =============================================
    {
      path: "Management/SmsReports",
      element: <SmsReportsPage />,
    },
    {
      path: "Management/FollowUpPerformanceReport",
      element: <FollowUpPerformanceReportPage />,
    },
    {
      path: "SolarentOperator/FollowUpPerformanceReport",
      element: <FollowUpPerformanceReportPage />,
    },
    {
      path: "Management/LeadConsultationFollowUpPerformanceReport",
      element: <LeadConsultationFollowUpPerformanceReportPage />,
    },
    {
      path: "SolarentOperator/LeadConsultationFollowUpPerformanceReport",
      element: <LeadConsultationFollowUpPerformanceReportPage />,
    },
    {
      path: "Management/OperationalProcessesReport",
      element: <ManagementOperationalProcessesReportPage />,
    },
    {
      path: "Management/OperationsOwnerPerformanceReport",
      element: <ManagementOperationsOwnerPerformanceReportPage />,
    },

    // ==================== Market Growth (license menu controllers) ====================
    ...marketGrowthSlnRouteEntries,

    // ==================== Contractor Portal (Phase 7.4.0 foundation) ====================
    ...contractorPortalSlnRouteEntries,

    {
      path: "SolarentOperator/OperationalProcessesReport",
      element: <SolarentOperatorOperationalProcessesReportPage />,
    },
    {
      path: "SolarentOperator/MehrsanWorkQueue",
      element: <SolarentOperatorMehrsanWorkQueuePage />,
    },
    {
      path: "SolarentOperator/ContractorReferralWorkQueue",
      element: <SolarentOperatorContractorReferralWorkQueuePage />,
    },
    {
      path: "SolarentOperator/SupervisionWorkQueue",
      element: <SolarentOperatorSupervisionWorkQueuePage />,
    },
    {
      path: "SolarentOperator/FulfillmentWorkQueue",
      element: <SolarentOperatorFulfillmentWorkQueuePage />,
    },
    {
      path: "SolarentOperator/SalesProforma",
      element: <SolarentOperatorSalesProformaPage />,
    },
    {
      path: "DistributionCompany/ReviewQueue",
      element: <LegacyReviewQueueRedirect />,
    },
    {
      path: "DistributionCompany/Team",
      element: <LegacyTeamRedirect />,
    },
    {
      path: "DistributionCompany",
      element: <LegacyReviewQueueRedirect />,
    },
    {
      path: "SolarentOperator/BarghPay",
      element: <SolarentOperatorBarghPayWorkQueuePage />,
    },
    {
      path: "SolarentOperator/IriaPay",
      element: <SolarentOperatorIriaPayWorkQueuePage />,
    },
    {
      path: "SolarentOperator/LoanDisbursements",
      element: <SolarentOperatorLoanDisbursementsPage />,
    },
    {
      path: "SolarentOperator/OperationsOwnerPerformanceReport",
      element: <SolarentOperatorOperationsOwnerPerformanceReportPage />,
    },
    {
      path: "MySmsHistory",
      element: <MySmsHistoryPage />,
    },

    // ==================== Satba (Ministry of Energy Dashboard) =============================================
    {
      path: "Satba",
      element: <SatbaDashboardPage />,
    },

    // ==================== Investor Dashboard =============================================
    {
      path: "Investor",
      element: <InvestorDashboardPage />,
    },
  ],
};
